import { render, staticRenderFns } from "./TonalAudiometryForm.vue?vue&type=template&id=6cb12743"
import script from "./TonalAudiometryForm.vue?vue&type=script&lang=js"
export * from "./TonalAudiometryForm.vue?vue&type=script&lang=js"
import style0 from "./TonalAudiometryForm.vue?vue&type=style&index=0&id=6cb12743&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports